import {Box, Card, CardActionArea, CardActions, CardContent, Stack, Typography} from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';
import PersonIcon from '@mui/icons-material/Person';
import PublicPagination from '../components/PublicPagination';
import React, {useEffect, useState} from "react";
import {Link, useSearchParams} from "react-router-dom";
import axios from "axios";
import {API_BASE, API_ENDPOINT} from "../config";
import {etichetaDataExpozitie} from '../components/dateExpozitie';
import {hideSplash} from '../splash';
import {ActiuniCard} from '../components/LikeButton';
import {useAprecieriMele} from '../utils/aprecieri';

// 29.1: datele expozitiei (cu „Vernisaj: …” pentru cele programate) vin din components/dateExpozitie.

const Thumbnail = ({poza}) => {
    const [failed, setFailed] = useState(false);
    useEffect(() => setFailed(false), [poza]);
    const style = {
        width: '100%', height: 160, borderRadius: '10px 10px 0 0',
        objectFit: 'cover', background: 'var(--gallery-paper)', color: 'var(--gallery-muted)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 32,
    };
    const src = poza && (/^https?:\/\//i.test(poza)
        ? poza : `${API_BASE.replace(/\/$/, '')}/${poza.replace(/^\/+/, '')}`);
    return src && !failed ? (
        <img src={src} alt="" loading="lazy" style={style} onError={() => setFailed(true)} />
    ) : (
        <span style={style} aria-hidden="true"><ImageIcon fontSize="large" /></span>
    );
};

const ExpozitiiListPage = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const pagina = Math.max(1, parseInt(searchParams.get('pagina') || '1', 10) || 1);

    const [items, setItems] = useState([]);
    const [paginare, setPaginare] = useState(null);
    const [loading, setLoading] = useState(true);
    const apreciat = useAprecieriMele({expozitii: items.map((e) => e.id)});
    // Ecranul de încărcare (src/splash.js) dispare când pagina are datele - fără „pâlpâire” la deschidere.
    useEffect(() => {
        if (!loading) hideSplash();
    }, [loading]);

    useEffect(() => {
        const controller = new AbortController();
        setLoading(true);
        axios.get(`${API_ENDPOINT}/public/expozitii`, {params: {pagina}, signal: controller.signal})
            .then(({data}) => { setItems(data.items); setPaginare(data.paginare); })
            .catch(() => { if (!controller.signal.aborted) { setItems([]); setPaginare(null); } })
            .finally(() => { if (!controller.signal.aborted) setLoading(false); });
        return () => controller.abort();
    }, [pagina]);

    const schimbaPagina = (p) => setSearchParams({pagina: p});

    return <Box className="public-detail">
        <Typography component="h1" variant="h4" sx={{mb: 3}}>Expoziții</Typography>
        {loading ? <Typography color="text.secondary" role="status">Se încarcă...</Typography> : items.length === 0 ? <Typography color="text.secondary">Nicio expoziție încă.</Typography> : <>
            <Box sx={{display: 'grid', gridTemplateColumns: {xs: 'minmax(0, 1fr)', sm: 'repeat(2, minmax(0, 1fr))', md: 'repeat(3, minmax(0, 1fr))'}, gap: 3}}>
                {items.map(e => <Card key={e.slug} variant="outlined" sx={{minWidth: 0, display: 'flex', flexDirection: 'column'}}>
                    <CardActionArea component={Link} to={`/expozitii/${e.slug}`} sx={{flexGrow: 1, display: 'block', textAlign: 'left'}}>
                        <Thumbnail poza={e.poza} />
                        <CardContent sx={{overflowWrap: 'anywhere'}}>
                        <Typography component="h2" variant="h6">{e.numeExpozitie}</Typography>
                        <Typography variant="body2" color="text.secondary">{etichetaDataExpozitie(e)}{e.online === true ? ' · Online' : e.address ? ` · ${e.address}` : ''}</Typography>
                        <Stack direction="row" useFlexGap spacing={1.5} sx={{mt: 1, flexWrap: 'wrap', color: 'text.secondary', fontSize: 13, justifyContent: 'flex-start'}}>
                            <Stack direction="row" spacing={0.5} alignItems="center"><PersonIcon fontSize="small" /><span>{e.numarArtisti ?? 0} artiști</span></Stack>
                            <Stack direction="row" spacing={0.5} alignItems="center"><ImageIcon fontSize="small" /><span>{e.numarLucrari ?? 0} lucrări</span></Stack>
                        </Stack>
                        </CardContent>
                    </CardActionArea>
                    {/* 54.5: actiunile stau in afara linkului cardului (butoane imbricate intr-un link nu sunt valide). */}
                    <CardActions sx={{px: 2, pb: 2, pt: 0}}>
                        <ActiuniCard tip="expozitii" item={e} nume={e.numeExpozitie} text={`Expoziția ${e.numeExpozitie}`}
                            cale={`/expozitii/${e.slug}`} apreciat={apreciat('expozitii', e.id)} sx={{width: '100%'}} />
                    </CardActions>
                </Card>)}
            </Box>
            <PublicPagination pagina={pagina} paginare={paginare} onChange={schimbaPagina} />
        </>}
    </Box>;
};

export default ExpozitiiListPage;
